var Theme = Theme || {};

Theme.InstitutionSsoAuth = (function ($) {

    return {
        init: _init
    };

    function _init() {
        if (!_myComponentIsOnPage()) {
            return;
        }

        handleCorporateSsoFormSubmit();
    }


    function _myComponentIsOnPage() {
        return $('.inst-sso-auth-wrap').length;
    }

    function handleCorporateSsoFormSubmit() {
        var $errorMessage = $('.js-error-msg');

        $('.js-institution-drop-down').on('change', function () {
            $errorMessage.text('');

            var $selectedOption = $(this).find('option:selected');
            if ($selectedOption.length) {
                var loginUrl = $selectedOption.attr('data-loginurl');

                $('.js-inst-sso-auth-login-link').attr('href', loginUrl);
            }
        });
    }
})(jQuery);